<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4a26H6/tc-custom/9781423640479.jpg?1709781184088" alt="This image is the cover for the book Patina Farm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Patina Farm
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The husband and wife team behind Giannetti Home welcome readers into their gorgeous farm residence </b><b>blending modern style with French antiques.</b><br/><br/> When Brooke and Steve Giannetti decided to leave their suburban Santa Monica home to build a new life on a farm, they traveled to Belgium and France for design inspiration. In <i>Patina Farm</i> they share their collaborative process, as well as the enviable result of their team effort and creativity: an idyllic farm in California’s Ojai Valley.<br/><br/> With two hundred gorgeous photographs and Steve’s architectural drawings, Brooke takes readers through their inspirations, thought process, and materials selections. Readers are given a full tour of the family home, guesthouse, lush gardens, and delightful animal quarters.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brooke Giannetti, Steve Giannetti, Lisa Romerein
      </h2>
      
      <p class="authorDescription body article">Steve Giannetti and Brooke Giannetti are an interior design team and owners of Giannetti Home, one of the top design stores in Los Angeles. Their work has been the focus of countless national magazine features and has graced the covers of Veranda and Coastal Living. Brooke Giannetti and Steve Giannetti are the owners of Giannetti Home, a full-service architecture, interior, and landscape design firm as well as a home furnishings store. Their work has been featured in numerous national magazines, newspapers and books, including Veranda, Coastal Living and the New York Times</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?88329870